
import { Button } from "@/components/ui/button";

interface NoResultsMessageProps {
  onClearFilters: () => void;
}

const NoResultsMessage = ({ onClearFilters }: NoResultsMessageProps) => {
  return (
    <div className="text-center py-12">
      <h3 className="text-lg font-semibold mb-2">No recipes match your filters</h3>
      <p className="text-muted-foreground mb-4">Try adjusting your search criteria or clear the filters.</p>
      <Button variant="outline" onClick={onClearFilters}>
        Clear Filters
      </Button>
    </div>
  );
};

export default NoResultsMessage;
